document.addEventListener('DOMContentLoaded', function() {
  const CONFIG = {
    cartCountSelectors: ['.cart-count', '.wbhcartitem'],
    quantityContainer: 'quantity-input',
    quantityInput: '.quantity__input',
    minusButton: 'button[name="minus"]',
    plusButton: 'button[name="plus"]',
    debounceTime: 300
  };

  let updateTimeout = null;
  let currentCart = { items: [], item_count: 0 };
  let cartWasEmpty = true;

  async function getCart() {
    try {
      const response = await fetch('/cart.js');
      currentCart = await response.json();
      cartWasEmpty = currentCart.item_count === 0;
      return currentCart;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return { items: [], item_count: 0 };
    }
  }
  function markInputAsPending(input, value) {
    input.dataset.evsPendingValue = String(value);
    input.dataset.evsPendingUntil = String(Date.now() + 2000);
  }
  function updateCartCounters() {
    CONFIG.cartCountSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.textContent = currentCart.item_count;
      });
    });

    // EVS FIX - Actualizar contador visible del header Viola:
    // <span class="qty_title"><strong>Carrito</strong><strong>(16)</strong></span>
    document.querySelectorAll('.qty_title').forEach(qtyTitle => {
      const strongs = qtyTitle.querySelectorAll('strong');

      if (strongs.length >= 2) {
        strongs[1].textContent = '(' + currentCart.item_count + ')';
      }
    });
  }

  function syncInputWithCart(input, variantId) {
    const pendingUntil = parseInt(input.dataset.evsPendingUntil || '0', 10);
    const pendingValue = input.dataset.evsPendingValue;

    // EVS FIX - Evita rebote visual 0→1→0→1 o 1→2→1→2
    // Si el usuario acaba de tocar +/-, no permitimos que una resincronización temprana
    // vuelva a pintar el valor viejo del carrito.
    if (pendingValue !== undefined && Date.now() < pendingUntil) {
      input.value = pendingValue;
      return;
    }

    delete input.dataset.evsPendingValue;
    delete input.dataset.evsPendingUntil;

    const cartItem = currentCart.items.find(item => item.variant_id.toString() === variantId.toString());
    input.value = cartItem ? cartItem.quantity : 0;
  }

  function setupQuantityInputs() {
    document.querySelectorAll(CONFIG.quantityContainer).forEach(container => {
      const input = container.querySelector(CONFIG.quantityInput);
      if (!input) return;

      const variantId = input.dataset.variantId;
      if (!variantId) return;

      const minusBtn = container.querySelector(CONFIG.minusButton);
      const plusBtn = container.querySelector(CONFIG.plusButton);
      const isDisabled = container.classList.contains('disabled');

      if (minusBtn && plusBtn) {
        const newMinusBtn = minusBtn.cloneNode(true);
        const newPlusBtn = plusBtn.cloneNode(true);

        minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);
        plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);

        newMinusBtn.addEventListener('click', function(e) {
          e.preventDefault();
          if (isDisabled) return;

          let currentValue = parseInt(input.value) || 0;

          if (currentValue > 0) {
            const newValue = currentValue - 1;

            input.value = newValue;
            markInputAsPending(input, newValue);

            updateCart(variantId, newValue);
          }
        });

        newPlusBtn.addEventListener('click', function(e) {
          e.preventDefault();
          if (isDisabled) return;

          let currentValue = parseInt(input.value) || 0;
          const newValue = currentValue + 1;

          input.value = newValue;
          markInputAsPending(input, newValue);

          updateCart(variantId, newValue);
        });
      }

      input.addEventListener('change', function() {
        if (isDisabled) {
          this.value = 0;
          return;
        }

        let newValue = parseInt(this.value) || 0;
        if (newValue < 0) newValue = 0;

        this.value = newValue;
        markInputAsPending(this, newValue);

        updateCart(variantId, newValue);
      });

      syncInputWithCart(input, variantId);
    });
  }

  async function updateCartUI() {
    try {
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      const wasEmpty = cartWasEmpty && cartData.item_count > 0;

      document.querySelectorAll('.cart-count, .wbhcartitem').forEach(el => {
        el.textContent = cartData.item_count;
      });

      // EVS FIX - Actualizar contador visible del header Viola
      document.querySelectorAll('.qty_title').forEach(qtyTitle => {
        const strongs = qtyTitle.querySelectorAll('strong');

        if (strongs.length >= 2) {
          strongs[1].textContent = '(' + cartData.item_count + ')';
        }
      });

      const drawerResponse = await fetch('/?section_id=cart-drawer');
      const drawerHtml = await drawerResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(drawerHtml, 'text/html');

      const newDrawer = doc.querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('#CartDrawer');

      if (newDrawer && currentDrawer) {
        // Actualizar el contenido del drawer
        currentDrawer.innerHTML = newDrawer.innerHTML;

        // Actualizar el componente cart-drawer
        const cartDrawerElement = document.querySelector('cart-drawer');
        if (cartDrawerElement && wasEmpty) {
          // Eliminar la clase is-empty cuando el carrito pasa de vacío a tener items
          cartDrawerElement.classList.remove('is-empty');

          // Asegurarse de que el drawer esté visible
          cartDrawerElement.style.visibility = 'visible';

          // Intentar abrir el drawer
          if (typeof cartDrawerElement.open === 'function') {
            setTimeout(() => {
              try {
                cartDrawerElement.open();
              } catch (e) {}
            }, 100);
          }
        }

        document.dispatchEvent(new CustomEvent('shopify:section:load', {
          detail: { sectionId: 'cart-drawer' }
        }));

        setTimeout(() => {
          setupQuantityInputs();
        }, 100);
      } else if (newDrawer && !currentDrawer) {
        document.body.insertAdjacentHTML('beforeend', newDrawer.outerHTML);

        const cartDrawerElement = document.querySelector('cart-drawer');
        if (cartDrawerElement) {
          cartDrawerElement.classList.remove('is-empty');
          cartDrawerElement.style.visibility = 'visible';

          document.dispatchEvent(new CustomEvent('shopify:section:load', {
            detail: { sectionId: 'cart-drawer' }
          }));

          setTimeout(() => {
            setupQuantityInputs();

            if (typeof cartDrawerElement.open === 'function') {
              try {
                cartDrawerElement.open();
              } catch (e) {}
            }
          }, 100);
        }
      }

    } catch (error) {
      console.error('Error al actualizar el carrito:', error);
    }
  }

  function updateCart(variantId, quantity) {
    clearTimeout(updateTimeout);

    updateTimeout = setTimeout(async () => {
      try {
        // Guardar si el carrito estaba vacío antes de la actualización
        cartWasEmpty = currentCart.item_count === 0;

        const cartItem = currentCart.items.find(item => item.variant_id.toString() === variantId.toString());

        if (quantity <= 0) {
          if (cartItem) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: cartItem.key,
                quantity: 0
              })
            });
          }
        } else if (cartItem) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: cartItem.key,
              quantity: quantity
            })
          });
        } else {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          });
        }

        await getCart();
        updateCartCounters();
        await updateCartUI();

      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }, CONFIG.debounceTime);
  }

  async function init() {
    await getCart();
    setupQuantityInputs();
    updateCartCounters();

    const cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      cartIcon.addEventListener('click', function(e) {
        // Si el carrito tiene items pero el drawer tiene la clase is-empty, corregirlo
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && currentCart.item_count > 0 && cartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.remove('is-empty');
        }
      });
    }
  }

  init();
});


document.addEventListener('DOMContentLoaded', function () {
  if (window.trapFocus) {
    const originalTrapFocus = window.trapFocus;

    window.trapFocus = function (container, elementToFocus = container) {
      if (!container) {
        const cartDrawer = document.querySelector('cart-drawer') ||
                          document.querySelector('#CartDrawer');

        if (cartDrawer) {
          try {
            originalTrapFocus(cartDrawer, cartDrawer);
          } catch (e) {}
        }

        return;
      }

      try {
        originalTrapFocus(container, elementToFocus);
      } catch (error) {}
    };
  }

  if (window.getFocusableElements) {
    const originalGetFocusableElements = window.getFocusableElements;

    window.getFocusableElements = function (container) {
      if (!container) return [];

      try {
        return originalGetFocusableElements(container);
      } catch (error) {
        return [];
      }
    };
  }
});